var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Hero",class:{
		'Hero--primary': _vm.color === 'primary',
		'Hero--black': _vm.color === 'black',
	}},[_c('div',{staticClass:"Hero-text"},[_vm._t("text")],2),_c('div',{staticClass:"Hero-image"},[_vm._t("image")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }